@if (task() && response) {
  <div class="responseDetail">
    <h3 class="responseHeader">{{ task().name }}</h3>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Entity ID:</label>
      </span>
      <span class="inputField">
        <label>{{ task().entityId }};{{ task().entityRevision }}</label>
      </span>
    </div>
    <div>
      <span class="spacerLabel"></span>
      <input class="radioInput" type="radio" id="approveResponse" value="Approve" name="outcome" [(ngModel)]="response.exceptionResponse"/>
      <label class="radioLabel" for="approveResponse">Approve - Unconditional Approval. Order will be approved and go to Engineering, Scheduling, and PRMS</label>
    </div>
    <div>
      <span class="spacerLabel"></span>
      <input class="radioInput" type="radio" id="notApprovedResponse" value="Not Approved" name="outcome" [(ngModel)]="response.exceptionResponse"/>
      <label class="radioLabel" for="notApprovedResponse">Not Approved - Order will not be approved and no transfer to Engineering, Scheduling, or PRMS will occur</label>
    </div>
    <div>
      <span class="spacerLabel"></span>
      <input class="radioInput" type="radio" id="noPrmsResponse" value="Approve No PRMS" name="outcome" [(ngModel)]="response.exceptionResponse"/>
      <label class="radioLabel" for="noPrmsResponse">Approve no PRMS - Order will approve, but ERP status will be changed to Credit Hold. Order will not transfer to PRMS until this status is changed to XferReady</label>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Comments</label>
      </span>
      <span>
        <textarea class="unresizable inputField" rows="3" cols="40" [(ngModel)]="response.comment"></textarea>
      </span>
    </div>
    <div class="toolbar">
      <span class="spacer"></span>
      <span>
        <button class="primary-button" matButton="elevated" [disabled]="!response || !response.exceptionResponse || isBusy()" (click)="saveResponse()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label>Complete Task</label>
          </span>
        </button>
      </span>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}

